import { useQuery } from 'react-query';
import {
  getBuddyPreferenceByUserProfileId,
  type BuddyPreferenceResponse
} from '../../services/findBuddyService';

export function useGetBuddyPreferenceByUserProfileId(userProfileId: string) {
  return useQuery<BuddyPreferenceResponse, Error, BuddyPreferenceResponse>(
    ['buddyPreference', userProfileId],
    () => getBuddyPreferenceByUserProfileId(userProfileId),
    {
      enabled: !!userProfileId
    }
  );
}
